<template>
  <div>
    <div v-if="campList.length > 0">
      <template v-if="campList && campListByPhase['1']">
        <div class="list-title col-lg-9 old-small-bold text-center">
          第一階段錄取名單
        </div>
        <div
          :class="
            'col-lg-9 list-row mt-3 mt-lg-0 d-flex flex-column flex-lg-row ' +
            'justify-content-between text-center'
          "
          v-for="data in campListByPhase['1']"
          :key="data.name"
        >
          <div class="institute col">{{ data.institute }}</div>
          <div
            :class="
              'student old-small col ' +
              'd-flex justify-content-center justify-content-lg-around'
            "
          >
            <template v-if="data.name != null">
              <div class="name text-center col-4">{{ data.name }}</div>
              <div class="school text-center col-8">{{ data.school }}</div>
            </template>
            <div v-else class="text-center">從缺</div>
          </div>
        </div>
      </template>
      <!-- <div v-else class="col-lg-9 text-center pt-1">尚未公布</div> -->
      <template v-if="campList && campListByPhase['2']">
        <div class="list-title col-lg-9 old-small-bold text-center">
          第二階段錄取名單
        </div>
        <div
          :class="
            'col-lg-9 list-row mt-3 mt-lg-0 d-flex flex-column flex-lg-row ' +
            'justify-content-between text-center'
          "
          v-for="data in campListByPhase['2']"
          :key="data.name"
        >
          <div class="institute col">{{ data.institute }}</div>
          <div
            :class="
              'student old-small col ' +
              'd-flex justify-content-center justify-content-lg-around'
            "
          >
            <template v-if="data.name != null">
              <div class="name text-center col-4">{{ data.name }}</div>
              <div class="school text-center col-8">{{ data.school }}</div>
            </template>
            <div v-else class="text-center">從缺</div>
          </div>
        </div>
      </template>
      <!-- <div v-else class="text-center pt-1">尚未公布</div> -->
      <template v-if="campList && campListByPhase['3']">
        <div class="list-title col-lg-9 old-small-bold text-center">
          第三階段錄取名單
        </div>
        <div
          :class="
            'col-lg-9 list-row mt-3 mt-lg-0 d-flex flex-column flex-lg-row ' +
            'justify-content-between text-center'
          "
          v-for="data in campListByPhase['3']"
          :key="data.name"
        >
          <div class="institute col">{{ data.institute }}</div>
          <div
            :class="
              'student old-small col ' +
              'd-flex justify-content-center justify-content-lg-around'
            "
          >
            <template v-if="data.name != null">
              <div class="name text-center col-4">{{ data.name }}</div>
              <div class="school text-center col-8">{{ data.school }}</div>
            </template>
            <div v-else class="text-center">從缺</div>
          </div>
        </div>
      </template>
      <!-- <div v-else class="col-lg-9 text-center pt-1">尚未公布</div> -->
    </div>
    <div v-else class="col-lg-9 text-center pt-1 h4-style">
      ～名單尚未公布～
    </div>
  </div>
</template>

<script>
import { getOverseasList } from '@/api/camp-list';

export default {
  name: 'CampCourses',
  data() {
    return {
      campList: [],
    };
  },
  computed: {
    campListByPhase() {
      return this.groupBy(this.campList, 'phase');
    },
  },
  methods: {
    groupBy(xs, key) {
      return xs.reduce((rv, x) => {
        // eslint-disable-next-line no-param-reassign
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getList() {
      const filter = { where: { group: parseInt(this.$route.params.groupId[5], 10), stage: 4 }, order: 'phase asc, sort asc' };
      getOverseasList({ filter }).then((response) => {
        this.campList = response;
      });
    },
  },
  created() {
    this.getList();
  },
  watch: {
    '$route.params.groupId': function () {
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'groupId')) this.getList();
    },
  },
};
</script>
<style lang="stylus" scoped>
.list-title
  padding-bottom: 8px;
  border-bottom: 1px solid $monoc4;

.list-row
  padding: 4px;

  + .list-title
    margin-top: 80px;

.name
  min-width: 100px;

@media screen and (max-width: 991.55px)
  .institute
    font-weight: bold;
</style>
